<template>
  <v-card tile flat>
    <v-card-title>
      <v-row>
        <v-col class="py-0">
          <v-text-field
            v-bind:value="textFilter"
            v-on:input="applyTextFilter"
            prepend-inner-icon="mdi-magnify"
            label="Filtra"
            clearable
            autofocus
            hide-details
          />
        </v-col>
        <v-col class="py-0">
          <v-select
            v-bind:value="validFilter"
            v-on:input="applyValidFilter"
            v-bind:items="validFilters"
            label="Filtra per stato"
            clearable
            hide-details
          />
        </v-col>
      </v-row>
      <v-spacer />
      <v-btn v-on:click="newUser" class="primary">Nuovo utente</v-btn>
    </v-card-title>

    <v-card-text style="position: relative;">
      <v-data-table
        v-bind:headers="headers"
        v-bind:options.sync="options"
        v-bind:items="rows"
        v-bind:server-items-length="totalRows"
        v-bind:loading="server_loading"
        v-bind:footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
        v-on:click:row="editUser"
        calculate-widths
      >
        <template v-slot:item.name="{ item }">
          <v-icon v-if="item.valid === '0'" class="mr-1 grey--text" small>mdi-eye-off</v-icon>
          <span v-bind:class="{ 'grey--text': item.valid === '0' }">{{ item.name }}</span>
        </template>
        <template v-slot:item.group="{ item }">
          {{ groupById[item.group] }}
        </template>
        <template v-slot:item.expiration="{ item }">
          {{ item.expiration | date }}
        </template>
        <template v-slot:item.services="{ item }">
          <v-icon v-if="item.filter_services === '1'">mdi-lock</v-icon>
          <template v-if="item.services">
            <v-chip
              v-for="service in item.services.split(',')"
              v-bind:key="service"
              class="mr-1"
              small
            >
              {{ serviceById[service] }}
            </v-chip>
          </template>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="editingUser" width="600">
      <v-card>
        <v-card-title>
          <span v-if="selectedUser.id">Modifica utente</span>
          <span v-if="!selectedUser.id">Nuovo utente</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="9">
                <v-text-field
                  ref="selectedUserName"
                  v-model="selectedUser.name"
                  label="Nome visualizzato all'interno dell'applicazione"
                  v-bind:rules="[rules.required]"
                />
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="selectedUser.active"
                  true-value="1"
                  false-value="0"
                  label="Attivo"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selectedUser.username"
                  label="Nome utilizzato per l'accesso"
                  v-bind:rules="[rules.required]"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-if="selectedUser.id"
                  v-model="selectedUser.password"
                  label="Password utilizzata per l'accesso"
                  hint="Se lasciato vuoto la password non viene cambiata"
                  persistent-hint
                />
                <v-text-field
                  v-if="!selectedUser.id"
                  v-model="selectedUser.password"
                  label="Password utilizzata per l'accesso"
                  v-bind:rules="[rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="selectedUser.group"
                  v-bind:items="groups"
                  label="Tipologia"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="selectedUser.expiration"
                  label="Accesso consentito fino al"
                  type="date"
                />
              </v-col>
            </v-row>
            <v-select
              v-model="selectedUser.serviceList"
              v-bind:items="services"
              label="Servizi associati"
              menu-props="top"
              small-chips
              clearable
              multiple
              deletable-chips
            />
            <v-checkbox
              v-model="selectedUser.filter_services"
              true-value="1"
              false-value="0"
              label="Questo utente può visualizzare solo i servizi scelti"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn class="primary" v-on:click="saveUser">Salva</v-btn>
          <v-btn class="primary" v-on:click="closeUser">Annulla</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import server from '../mixins/server'
import utils from '../mixins/utils'

export default {
  name: 'Users',

  mixins: [ server, utils ],

  data: () => ({
    headers: [
      { text: 'Nome', value: 'name', width: '20%' },
      { text: 'Gruppo', value: 'group', width: '20%' },
      { text: 'Scadenza', value: 'expiration', width: '20%' },
      { text: 'Servizi associati', value: 'services', width: '40%', sortable: false },
    ],
    textFilter: '',
    validFilter: 1,
    validFilters: [
      { text: 'Attivi', value: 1 },
      { text: 'Non attivi', value: 2 },
    ],
    totalRows: 0,
    rows: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['name'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    rules: {
      required: value => !!value || 'Valore richiesto.',
    },
    valid: false,
    selectedUser: {},
    services: [],
    serviceById: {},
    groups: [],
    groupById: {},
  }),

  watch: {
    options: {
      handler () { this.loadRows(); },
      deep: true,
    },
    editingUser: {
      handler (newValue) { newValue && this.utils_focusInput('selectedUserName', 200); }
    },
  },

  computed: {
    editingUser: {
      get: function() { return 'id' in this.selectedUser; },
      set: function(value) { if (!value) this.selectedUser = {}; },
    },
  },

  mounted: function() {
    // Load groups
    this.server_query({
      url: 'User/groups',
      onSuccess: (data) => {
        this.groups = data.map(element => ({
          value: element.id,
          text: element.name,
        }));

        this.groupById = data.reduce((result, element) => {
          result[element.id] =  element.name;
          return result;
        }, {});
      },
    });

    // Load services
    this.server_query({
      url: 'Service/list',
      onSuccess: (data) => {
        this.serviceById = data.rows.reduce((result, element) => {
          result[element.id] =  element.description;
          return result;
        }, {});

        this.services = data.rows.reduce((result, element) => {
          if (element.active)
            result.push({
              value: element.id,
              text: element.description,
            })
          return result;
        }, []);
      },
    });
  },

  methods: {
    applyTextFilter: function(value) {
      this.textFilter = value;
      this.applyFilter();
    },

    applyValidFilter: function(value) {
      this.validFilter = value;
      this.applyFilter();
    },

    applyFilter: function() {
      // When appling the filter we move to first page and this
      // forces the reload of the rows
      this.utils_delayExecute((this.options.page != 1) ? this.loadFirstPage : this.loadRows);
    },

    loadFirstPage: function() {
      this.options.page = 1;
    },

    loadRows: function() {
      const parameters = {};

      parameters['page'] = this.options.page;
      parameters['rows'] = this.options.itemsPerPage;

      // Add filter
      if (this.textFilter) {
        parameters['filter'] = this.textFilter;
      }
      if (this.validFilter) {
        parameters['valid'] = (this.validFilter === 1);
      }

      // Add sorting
      if (this.options.sortBy.length > 0) {
        parameters['order'] = this.options.sortBy[0];
        if (this.options.sortDesc[0]) {
          parameters['order'] = '-' + parameters['order'];
        }
      }

      this.server_query({
        url: 'User/list',
        parameters: parameters,
        onError: () => {
          this.rows = [];
          this.totalRows = 0;
        },
        onSuccess: (data) => {
          this.rows = data.rows;
          this.totalRows = data.total;
        },
      });
    },

    newUser: function() {
      this.selectedUser = {
        id: 0,
        active: '1',
        name: '',
        group: '1',
        serviceList: []
      };
    },

    editUser: function(item) {
      this.selectedUser = Object.assign({
        serviceList: item.services ? item.services.split(',').map(service => parseInt(service)) : []
      }, item);
    },

    closeUser: function() { this.selectedUser = {}; },

    saveUser: function() {
      // Validate form first
      if (this.$refs.form.validate()) {
        this.selectedUser.services = this.selectedUser.serviceList.join(',');
        const parameters = {
          url: `User/index/${this.selectedUser.id || 0}`,
          data: this.selectedUser,
          onSuccess: () => {
            this.closeUser();
            this.loadRows();
          }
        };

        if (this.selectedUser.id) {
          this.server_update(parameters);
        } else {
          this.server_save(parameters);
        }
      }
    },
  }
}
</script>
